module.exports = __webpack_public_path__ + "img/parent-child-1.857f168b.png";